import React from "react";
import WhoWeAre from "../components/Aboutus/WhoWeAre";
import { motion } from "framer-motion";
import OurVisionMIssion from "../components/Aboutus/OurVisionMIssion";
import WhyChooseus from "../components/Aboutus/WhyChooseus";
import OurRegistrationDetails from "../components/Aboutus/OurRegistrationDetails";
import Banner from "../components/Banner";

const Aboutus = () => {
  return (
    <>
      <WhoWeAre />

      <img
        src="logo1.png"
        class=" mx-auto w-1/2 md:w-1/4 mix-blend-multiply py-20"
        alt="Upscaled Logo"
      />

      <OurVisionMIssion />
      <WhyChooseus />
      <OurRegistrationDetails />
      <Banner />
    </>
  );
};

export default Aboutus;
